import { OrganizationsTableProvider } from './OrganizationsTableContext'
import OrganizationsTable from './components/OrganizationsTable'

const Organizations: React.FC = () => (
  <OrganizationsTableProvider>
    <OrganizationsTable />
  </OrganizationsTableProvider>
)

export default Organizations
